import { render, staticRenderFns } from "./preformatted-modal-additional-report.vue?vue&type=template&id=18f76c92&scoped=true&"
import script from "./preformatted-modal-additional-report.ts?vue&type=script&lang=ts&"
export * from "./preformatted-modal-additional-report.ts?vue&type=script&lang=ts&"
import style0 from "./preformatted-modal-additional-report.scss?vue&type=style&index=0&id=18f76c92&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f76c92",
  null
  
)

export default component.exports